import { render } from "./HeaderUserSpace.vue?vue&type=template&id=d4b27e86&ts=true"
import script from "./HeaderUserSpace.vue?vue&type=script&lang=ts"
export * from "./HeaderUserSpace.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/soctio/events/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__